module.exports = __webpack_public_path__ + "static/media/ProWeb.cb158aca.png";